export default {
  // 设置页面
  PickGameTitle: "挑人转盘-游戏设置",
  candidatesLabel: "候选名字设置",
  candidatesPlaceholder: "输入候选名字，可用换行或逗号(,)分隔，按下Enter添加项目，最大候选数为20个，超过10个则随机挑选",
  clearSettings: "清空设置",
  saveSettings: "保存设置",
  candidateExists: "候选名字已存在",
  maxCandidates: "最多只能添加20个候选名字",
  unsubmittedWarning: "发现输入框中尚有未按下Enter的项目，请确认后再保存!",

  // 游戏页面
  gameTitle: "挑人转盘",
  spinWheel: "转动转盘",
  winner: "挑中了",
  spinAgain: "再转一次",
  backToSettings: "返回设置"
}